import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=35b1a703&scoped=true&"
import script from "./contact-card.ts?vue&type=script&lang=ts&"
export * from "./contact-card.ts?vue&type=script&lang=ts&"
import style0 from "./contact-card.scss?vue&type=style&index=0&id=35b1a703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1a703",
  null
  
)

export default component.exports